// extracted by mini-css-extract-plugin
export var documentation = "_l1-1";
export var menu = "_l1-0";